import { FieldProps } from "formik";
import React from "react";
import Select from "react-select";

export const MultiSelectField = ({
  className,
  placeholder,
  field,
  form,
  options,
}) => {
  const onChange = (option) => {
    form.setFieldValue(
      field.name,
      option.map((item) => item.value)
    );
  };
  const getValue = () => {
    return options.filter((option) => field.value.includes(option.value));
  };

  return (
    <Select
      id={field.id}
      name={field.name}
      isMulti
      value={getValue()}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    />
  );
};

export default MultiSelectField;
